import { rootContainer } from '~/container'
import { PuLangFetch } from '~/lang/utils/pulangfetch'
import { RecentCampsiteDataRepositoryFetch } from './RecentCampsiteDataRepositoryFetch'
import { RecentCampsiteRepositoryLocalStorage } from './RecentCampsiteRepositoryLocalStorage'
import {
  RecentCampsiteDataRepository,
  RecentCampsiteRepository,
} from './repositories'
import { RecentCampsiteDetails } from './types'

export class RecentCampsiteDetailsService {
  constructor(
    private recentCampsiteRepository: RecentCampsiteRepository,
    protected campsiteDataRepository: RecentCampsiteDataRepository,
  ) {}

  async getAll(
    langCode: string,
    {
      limit,
    }: {
      limit?: number
    },
  ): Promise<RecentCampsiteDetails[]> {
    const recents = await this.recentCampsiteRepository.getAll(langCode, limit)
    const campsitesData = await Promise.all(
      recents.map(({ id }) =>
        this.campsiteDataRepository.getById(id, langCode),
      ),
    )
    return campsitesData
      .filter((campsite) => !!campsite)
      .map((campsite, index) => ({
        ...campsite,
        visitDate: recents[index].visitDate,
      }))
  }
}

// Everything below (related to inversify) here is only used until we get rid of inversify completely
export function getRecentCampsiteDetailsService() {
  return new RecentCampsiteDetailsService(
    new RecentCampsiteRepositoryLocalStorage(),
    new RecentCampsiteDataRepositoryFetch(rootContainer.get(PuLangFetch)),
  )
}
